import { CheckOutlined, Close } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import type { FieldValues } from 'react-hook-form'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface DrawerActionsProps<TFieldValues> {
  hasChanges: boolean
  onClose: () => void
  onSave: (updatedData: TFieldValues) => void
}

export function DrawerActions<TFieldValues extends FieldValues>({
  hasChanges,
  onClose,
  onSave,
}: Readonly<DrawerActionsProps<TFieldValues>>) {
  const { t } = useTranslation()
  const { handleSubmit } = useFormContext<TFieldValues>()

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'right',
      }}
    >
      <Button startIcon={<Close />} sx={{ mr: 1 }} onClick={onClose}>
        {t('common.button.cancel')}
      </Button>
      <Button
        color="primary"
        disabled={!hasChanges}
        startIcon={<CheckOutlined />}
        variant="contained"
        onClick={handleSubmit(onSave)}
      >
        {t('controllers.configuration.common.configure')}
      </Button>
    </Box>
  )
}
